import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from 'posthog-js/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


import App from './App';
import { store, persistor } from './lib/store';
import RouteLoading from './components/Loaders/RouteLoading';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import NotificationsProvider from './context/NotificationsContext';

import './index.css';
import { MuiThemeProvider } from './context/MUIThemeProvider/MuiThemeProvider';

import UserLayout from './Layout/UserLayout';

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2025-11-30',
  capture_pageview: false,
  loaded: (posthogInstance) => {
    posthogInstance.config.autocapture = false;
  },
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
            <MuiThemeProvider>
              <NotificationsProvider>
                <PersistGate loading={<UserLayout isLoading={true} />} persistor={persistor}>
                  <App />
                </PersistGate>
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  icon={true}
                  closeButton
                />
              </NotificationsProvider>
            </MuiThemeProvider>
          </PostHogProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
